import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";
import DetailsPageHeader from "../../../../common/DetailsPageHeader";
import Sidebar from "../../../../common/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AreaAlbumsTableHeadCells,
  drawerWidth,
  mainLayoutStyles,
  routes,
  showNotification,
} from "../../../../constants";

import { albumsSearch } from "../../../OrganizationAlbums/hooks/AlbumsHooks";

import { updateArea } from "../../hooks/AreaHook";
import CommonTable from "../../../../common/CommonTable";
import TableSearchBar from "../../../../common/TableSearchBar";
import { useAuth } from "../../../../hooks";
import { useAlbumsContext } from "../../../../providers/OrganizationAdmin/AlbumProvider";
import AreaAlbumsTableRow from "../../../../common/AreaAlbumsTableRow";

const AddAlbumsToAreaContainer = () => {
  const { currentUser } = useAuth();
  const { loading, setLoading, handleGetAllAlbums, allAlbums } =
    useAlbumsContext();

  const location = useLocation();
  const navigate = useNavigate();

  const [areaDetails, setAreaDetails] = useState(location.state.areaDetails);
  // const idsToRemove = areaDetails?.albumsAndQTs ?? []; // IDs to remove from the albums
  const [albumsInOrg, setAlbumsInOrg] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (allAlbums?.length > 0) {
    } else {
      handleGetAllAlbums();
    }
  }, [handleGetAllAlbums]);

  useEffect(() => {
    setAreaDetails(location.state.areaDetails);
    let temp = [];
    if (location.state.areaDetails.albumsAndQTs) {
      areaDetails.albumsAndQTs.forEach((item) => {
        temp.push(item.id);
      });
    }
    const filteredAlbums = allAlbums.filter(
      (album) => !temp.includes(album.id)
    );
    console.log("idsToRemove", temp);
    setAlbumsInOrg(filteredAlbums);
  }, [location.state, allAlbums]);

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  const handleSearchAlbums = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let albumsSearchTemp = await albumsSearch(allAlbums, value);
        setAlbumsInOrg(albumsSearchTemp);
      } else {
        setAlbumsInOrg(allAlbums);
      }
    } catch (error) {
      console.log("error searching albums:", error.message);
    }
  };

  const handleSaveAlbums = async (selectedAlbums) => {
    console.log("selectedID", selectedAlbums);
    try {
      // const existingAlbums = areaDetails?.albums || [];
      // const updatedAlbums = [...selectedAlbums, ...existingAlbums];
      // const uniqueAlbums = [...new Set(updatedAlbums)];
      // console.log("Merged albums:", uniqueAlbums);
      // let dataTemp = {
      //   albums: uniqueAlbums,
      //   updatedAt: new Date(),
      //   updatedBy: currentUser?.id,
      // };
      const existingAlbums = areaDetails?.albumsAndQTs || [];
      const updatedAlbums = [...existingAlbums];
      let count = existingAlbums.length + 1;
      selectedAlbums.forEach((element) => {
        updatedAlbums.push({
          id: element,
          type: "albums",
          position: count,
        });
        count++;
      });
      const uniqueAlbums = [...new Set(updatedAlbums)];
      console.log("Merged albums:", uniqueAlbums);
      let dataTemp = {
        albumsAndQTs: uniqueAlbums,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      console.log("dataTemp", dataTemp);

      let responseTemp = await updateArea(areaDetails.id, dataTemp);
      setAreaDetails((prevDetails) => ({
        ...prevDetails,
        albumsAndQTs: updatedAlbums,
      }));

      let temp = [];
      if (location.state.areaDetails.albumsAndQTs) {
        areaDetails.albumsAndQTs.forEach((item) => {
          temp.push(item.id);
        });
      }

      const allIdsToRemove = [...temp, ...selectedAlbums];
      // const allIdsToRemove = [...idsToRemove, ...selectedAlbums];

      const filteredAlbums = allAlbums.filter(
        (album) => !allIdsToRemove.includes(album.id)
      );
      setAlbumsInOrg(filteredAlbums);
      // await handleGetAllAlbums();

      setSelected([]);
      showNotification("Area albums added successfully.");

      // Toast("success", "Area albums added successfully.");
    } catch (error) {
      console.log("error updating area albums:", error.message);
    }
  };

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={`Add Albums to '${areaDetails && areaDetails.name}'`}
        bgColor="#fff"
        buttonText={"Edit"}
        selected={selected}
        setSelected={setSelected}
        editEnabled={true}
        cancelButton={true}
        submitButtonText={"Submit"}
        loading={loading}
        onCancelClick={() => {
          navigate(routes.areaDetails, {
            state: { areaDetails },
          });
        }}
        handleSave={() => handleSaveAlbums(selected)}
      />
      <Sidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          <TableSearchBar
            placeholder={"Search Albums"}
            handleSearch={handleSearchAlbums}
          />

          <CommonTable
            tableData={albumsInOrg}
            selected={selected}
            setSelected={setSelected}
            CommonTableRow={AreaAlbumsTableRow}
            showPosition={false}
            tableHeadData={AreaAlbumsTableHeadCells}
          />
        </Grid>
      </Grid>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default AddAlbumsToAreaContainer;

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};
